import { connect } from "react-redux";

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");

require("appdev/wizards/direct_school_org_creation.scss");

@connect(
	(state, props) => {
		var loading = !!(
			RosterSelectors.isLoadingSchoolOrgs({ state, key: "create" }) ||
			RosterSelectors.isLoadingDistrictOrgs({ state, key: "create" })
		)

		return {
			loading
		}
	},
	(dispatch, props) => ({
		createSchoolOrg: (schoolOrg) => {
			function showError(message) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Error!", text: message, 
					icon: "exclamation-sign", type: "error" });
			}

			return dispatch(
				RosterActions.createSchoolOrg({ schoolOrg })
			).then((response) => {
				var schoolOrg = (response.schoolOrgs || [])[0];

				if (!schoolOrg) {
					showError("No school org created!");
					return { success: false };
				}

				if (schoolOrg.errors) {
					showError(schoolOrg.errors.join(", "));
					return { success: false };
				}

				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", 
					text: "School org created with ID: " + schoolOrg.id, 
					icon: "ok-sign", 
					type: "success" 
				});

				return { success: true, schoolOrg };
			});
		},

		createDistrictOrg: (districtOrg) => {
			function showError(message) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Error!", text: message, 
					icon: "exclamation-sign", type: "error" });
			}

			return dispatch(
				RosterActions.createDistrictOrg({ districtOrg })
			).then((response) => {
				var districtOrg = (response.districtOrgs || [])[0];

				if (!districtOrg) {
					showError("No district org created!");
					return { success: false };
				}

				if (districtOrg.errors) {
					showError(districtOrg.errors.join(", "));
					return { success: false };
				}

				window.wrNotifications.triggerDropDownNotification({
					title: "Success!", 
					text: "District org created with ID: " + districtOrg.id, 
					icon: "ok-sign", 
					type: "success" 
				});

				return { success: true, districtOrg };
			});
		},
	})
)
class DirectSchoolOrgCreationPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			orgType: "school", // "school" or "district"
			
			// School fields
			schoolName: "",
			districtName: "",
			schoolZip: "",
			schoolCanonicalId: "",
			districtOrgId: "",
			
			// District fields
			districtNameForDistrict: "",
			districtZip: "",
			districtCanonicalId: "",
			schoolOrgIds: "",
			
			createdOrgId: null,
			createdOrgType: null
		};
	}

	validateSchoolForm() {
		if (!this.state.schoolName.trim()) {
			this.showError("School name is required");
			return false;
		}
		if (!this.state.schoolZip.trim()) {
			this.showError("ZIP code is required");
			return false;
		}
		if (!/^\d{5}$/.test(this.state.schoolZip.trim())) {
			this.showError("ZIP code must be 5 digits");
			return false;
		}
		return true;
	}

	validateDistrictForm() {
		if (!this.state.districtNameForDistrict.trim()) {
			this.showError("District name is required");
			return false;
		}
		if (!this.state.districtZip.trim()) {
			this.showError("ZIP code is required");
			return false;
		}
		if (!/^\d{5}$/.test(this.state.districtZip.trim())) {
			this.showError("ZIP code must be 5 digits");
			return false;
		}
		return true;
	}

	showError(message) {
		window.wrNotifications.triggerDropDownNotification({
			title: "Validation Error", 
			text: message, 
			icon: "exclamation-sign", 
			type: "error" 
		});
	}

	onSubmitSchool(e) {
		$wr.nope(e);
		
		if (!this.validateSchoolForm()) {
			return;
		}

		var schoolInfo = {
			name: this.state.schoolName.trim(),
			zip: this.state.schoolZip.trim()
		};

		// Add optional fields
		if (this.state.districtName.trim()) {
			schoolInfo.district_name = this.state.districtName.trim();
		}
		if (this.state.schoolCanonicalId.trim()) {
			schoolInfo.canonical_id = this.state.schoolCanonicalId.trim();
		}

		var schoolOrgData = {
			school_info: schoolInfo
		};

		// Add district org relationship if provided
		if (this.state.districtOrgId.trim()) {
			schoolOrgData.district_org_id = parseInt(this.state.districtOrgId.trim(), 10);
		}

		this.props.createSchoolOrg(schoolOrgData).then((result) => {
			if (result.success) {
				this.setState({ 
					createdOrgId: result.schoolOrg.id,
					createdOrgType: "school"
				});
			}
		});
	}

	onSubmitDistrict(e) {
		$wr.nope(e);
		
		if (!this.validateDistrictForm()) {
			return;
		}

		var districtOrgData = {
			name: this.state.districtNameForDistrict.trim(),
			zip: this.state.districtZip.trim()
		};

		// Add optional fields
		if (this.state.districtCanonicalId.trim()) {
			districtOrgData.canonical_id = this.state.districtCanonicalId.trim();
		}
		if (this.state.schoolOrgIds.trim()) {
			// Parse comma-separated school org IDs
			districtOrgData.school_org_ids = this.state.schoolOrgIds
				.split(',')
				.map(id => parseInt(id.trim(), 10))
				.filter(id => !isNaN(id));
		}

		this.props.createDistrictOrg(districtOrgData).then((result) => {
			if (result.success) {
				this.setState({ 
					createdOrgId: result.districtOrg.id,
					createdOrgType: "district"
				});
			}
		});
	}

	resetForm(e) {
		if (e) $wr.nope(e);
		
		this.setState({
			orgType: "school",
			schoolName: "",
			districtName: "",
			schoolZip: "",
			schoolCanonicalId: "",
			districtOrgId: "",
			districtNameForDistrict: "",
			districtZip: "",
			districtCanonicalId: "",
			schoolOrgIds: "",
			createdOrgId: null,
			createdOrgType: null
		});
	}

	renderSuccessMessage() {
		var orgTypeLabel = this.state.createdOrgType === "school" ? "School" : "District";
		var detailsLink = this.state.createdOrgType === "school" 
			? `/school_orgs/${this.state.createdOrgId}/details/controls`
			: `/district_orgs/${this.state.createdOrgId}/details/controls`;

		return (
			<div className="successSection">
				<div className="alert alert-success">
					<Glyphicon icon="ok-sign" />{" "}
					<strong>Success!</strong> { orgTypeLabel } org created with ID: { this.state.createdOrgId }
				</div>
				<div className="actions">
					<a href={ detailsLink } className="btn buttonPrimary">
						View { orgTypeLabel } Org Details
					</a>{" "}
					<button className="btn buttonDefault" onClick={ this.resetForm }>
						Create Another Org
					</button>
				</div>
			</div>
		);
	}

	renderSchoolForm() {
		return (
			<form onSubmit={ this.onSubmitSchool }>
				<div className="formSection">
					<h3>School Information</h3>
					<p className="helpText">
						Create a new school organization. This bypasses Zendesk Sell and creates the org directly.
					</p>
					
					<div className="row">
						<div className="col-sm-6">
							<label className="normal blockLbl">
								School Name <span className="required">*</span>
								<input 
									className="form-control" 
									value={ this.state.schoolName }
									onChange={ (e) => this.setState({ schoolName: e.target.value }) }
									placeholder="e.g., Lincoln Elementary School"
								/>
							</label>
						</div>
						<div className="col-sm-3">
							<label className="normal blockLbl">
								ZIP Code <span className="required">*</span>
								<input 
									className="form-control" 
									value={ this.state.schoolZip }
									type="text"
									pattern="[0-9]{5}"
									maxLength="5"
									onChange={ (e) => this.setState({ schoolZip: e.target.value }) }
									placeholder="12345"
								/>
								<div className="helpText">5-digit ZIP code</div>
							</label>
						</div>
					</div>

					<div className="row">
						<div className="col-sm-6">
							<label className="normal blockLbl">
								District Name (Optional)
								<input 
									className="form-control" 
									value={ this.state.districtName }
									onChange={ (e) => this.setState({ districtName: e.target.value }) }
									placeholder="e.g., Lincoln Unified School District or 'No District'"
								/>
								<div className="helpText">
									Use "No District" for independent schools or "ZDS Contact [id]" to reference ZDS
								</div>
							</label>
						</div>
						<div className="col-sm-3">
							<label className="normal blockLbl">
								Canonical School ID (Optional)
								<input 
									className="form-control" 
									value={ this.state.schoolCanonicalId }
									onChange={ (e) => this.setState({ schoolCanonicalId: e.target.value }) }
									placeholder="e.g., 123456"
								/>
								<div className="helpText">From canonical schools database</div>
							</label>
						</div>
					</div>

					<div className="row">
						<div className="col-sm-4">
							<label className="normal blockLbl">
								District Org ID (Optional)
								<input 
									className="form-control" 
									value={ this.state.districtOrgId }
									type="number"
									onChange={ (e) => this.setState({ districtOrgId: e.target.value }) }
									placeholder="e.g., 789"
								/>
								<div className="helpText">
									Link to existing WR district org
								</div>
							</label>
						</div>
					</div>
				</div>

				<div className="actions">
					<LoadingButton 
						className="btn buttonSuccess" 
						text="Create School Org"
						loading={ this.props.loading }
					/>
				</div>
			</form>
		);
	}

	renderDistrictForm() {
		return (
			<form onSubmit={ this.onSubmitDistrict }>
				<div className="formSection">
					<h3>District Information</h3>
					<p className="helpText">
						Create a new district organization. This bypasses Zendesk Sell and creates the org directly.
					</p>
					
					<div className="row">
						<div className="col-sm-6">
							<label className="normal blockLbl">
								District Name <span className="required">*</span>
								<input 
									className="form-control" 
									value={ this.state.districtNameForDistrict }
									onChange={ (e) => this.setState({ districtNameForDistrict: e.target.value }) }
									placeholder="e.g., Lincoln Unified School District"
								/>
							</label>
						</div>
						<div className="col-sm-3">
							<label className="normal blockLbl">
								ZIP Code <span className="required">*</span>
								<input 
									className="form-control" 
									value={ this.state.districtZip }
									type="text"
									pattern="[0-9]{5}"
									maxLength="5"
									onChange={ (e) => this.setState({ districtZip: e.target.value }) }
									placeholder="12345"
								/>
								<div className="helpText">5-digit ZIP code</div>
							</label>
						</div>
					</div>

					<div className="row">
						<div className="col-sm-4">
							<label className="normal blockLbl">
								Canonical District ID (Optional)
								<input 
									className="form-control" 
									value={ this.state.districtCanonicalId }
									onChange={ (e) => this.setState({ districtCanonicalId: e.target.value }) }
									placeholder="e.g., 456789"
								/>
								<div className="helpText">From canonical schools database</div>
							</label>
						</div>
						<div className="col-sm-6">
							<label className="normal blockLbl">
								School Org IDs (Optional)
								<input 
									className="form-control" 
									value={ this.state.schoolOrgIds }
									onChange={ (e) => this.setState({ schoolOrgIds: e.target.value }) }
									placeholder="e.g., 123, 456, 789"
								/>
								<div className="helpText">
									Comma-separated list of existing WR school org IDs to associate
								</div>
							</label>
						</div>
					</div>
				</div>

				<div className="actions">
					<LoadingButton 
						className="btn buttonSuccess" 
						text="Create District Org"
						loading={ this.props.loading }
					/>
				</div>
			</form>
		);
	}

	render() {
		if (this.state.createdOrgId) {
			return (
				<div className="directSchoolOrgCreationPage container">
					<header className="pageHeader">
						<h1>Direct School/District Org Creation</h1>
					</header>

					{ this.renderSuccessMessage() }
				</div>
			);
		}

		return (
			<div className="directSchoolOrgCreationPage container">
				<header className="pageHeader">
					<h1>Direct School/District Org Creation</h1>
					<p className="subtitle">
						Create school or district orgs directly, bypassing Zendesk Sell integration
					</p>
				</header>

				<div className="alert alert-info">
					<Glyphicon icon="info-sign" />{" "}
					<strong>Note:</strong> This page allows you to create school and district orgs 
					without requiring a Deal or Contact from Zendesk Sell. Use this when ZDS integration 
					is unavailable or for quick org creation.
				</div>

				<div className="orgTypeSelector">
					<label className="normal">
						<strong>Organization Type:</strong>
					</label>
					<div className="btn-group" role="group">
						<button 
							type="button"
							className={ "btn " + (this.state.orgType === "school" ? "buttonPrimary" : "buttonDefault") }
							onClick={ () => this.setState({ orgType: "school" }) }
						>
							School
						</button>
						<button 
							type="button"
							className={ "btn " + (this.state.orgType === "district" ? "buttonPrimary" : "buttonDefault") }
							onClick={ () => this.setState({ orgType: "district" }) }
						>
							District
						</button>
					</div>
				</div>

				{ this.state.orgType === "school" ? this.renderSchoolForm() : this.renderDistrictForm() }
			</div>
		);
	}
}

DirectSchoolOrgCreationPage.WrappedComponent.propTypes = PageStrictPropTypes({
	loading: PropTypes.bool,
	createSchoolOrg: PropTypes.func.isRequired,
	createDistrictOrg: PropTypes.func.isRequired
});

module.exports = DirectSchoolOrgCreationPage;



// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/DirectSchoolOrgCreationPage.js